import React from "react";
import styled from "styled-components";
import {Field, Form} from "react-final-form";
import {
  FormContainer,
  FormHeader,
} from "src/core/common/components/collections/form/forms";
import ColumnLayout from "src/core/common/components/elements/container/column";
import RowLayout from "src/core/common/components/elements/container/row";
import Modal from "src/core/common/components/modules/modal/Modal";
import {
  composeValidators,
  passwordValidator,
  required,
} from "src/core/common/validations";
import PasswordInput from "src/core/common/components/elements/input/PasswordInput";
import {showErrorHighlight} from "src/core/common/utils";
import Error from "src/core/common/components/elements/Error";
import {PrimaryLoadingButton} from "src/core/common/components/elements/button/PrimaryButton";
import {ModalBackButton} from "src/core/common/components/modules/modal/modalComponents";
import useRouter from "src/core/common/hooks/useRouter";
import PhoneInputField from "src/core/common/components/elements/input/PhoneInput";

export default function SetPasswordWithTokenModal({
  title,
  buttonText,
  helpText,
  onSubmit,
  loading,
  closeModal,
}) {
  const router = useRouter();
  const requestPhone = router.query.request_phone === "true";

  return (
    <Modal isOpen onRequestClose={closeModal}>
      <ModalBackButton onClick={closeModal} />
      <Form
        onSubmit={onSubmit}
        validate={() => {}}
        render={({handleSubmit}) => (
          <form onSubmit={handleSubmit}>
            <FormContainer>
              <FormHeader>{title}</FormHeader>
              {/* trick chrome into not auto completing */}
              <input style={{display: "none"}} />
              {requestPhone && (
                <ColumnLayout>
                  <RowLayout>
                    <Label>{helpText}</Label>
                    <PhoneInputField name={"phoneNumber"} isRequired={true} />
                  </RowLayout>
                </ColumnLayout>
              )}

              <ColumnLayout>
                <RowLayout>
                  <Field
                    name="password"
                    validate={composeValidators(required, passwordValidator)}
                    render={({input, meta}) => (
                      <>
                        <PasswordInput
                          {...input}
                          disableAutoComplete={true}
                          autoComplete="new-password"
                          hasErrors={showErrorHighlight(meta)}
                          placeholder={"Password"}
                        />
                        {meta.touched && <Error>{meta.error}</Error>}
                      </>
                    )}
                  />
                </RowLayout>
              </ColumnLayout>

              <PrimaryLoadingButton loading={loading} type="submit" label={buttonText} />
            </FormContainer>
          </form>
        )}
      />
    </Modal>
  );
}

const Label = styled.span`
  margin-bottom: 10px;
`;
